export function isNonEmpty<T>(arr: T[]): arr is [T, ...T[]] {
  return arr.length > 0
}

export function hasIndex<T>(
  arr: readonly T[],
  index: number,
): arr is readonly (T & {})[] {
  return index >= 0 && index < arr.length
}

export function first<T>(arr: readonly T[]): T | undefined {
  return arr[0]
}

export function last<T>(arr: readonly T[]): T | undefined {
  return arr[arr.length - 1]
}